import { TimePeriod } from '../../models';
import { LogbookTableConfiguration } from './LogbookTable.configuration';

export function timeRangeRetroCompatibility(configuration: LogbookTableConfiguration): TimePeriod {
    if (configuration && configuration.timeRange === undefined) {
        if (configuration.hasTimeRange === false) {
            configuration.timeRange = TimePeriod.None;
        } else if (configuration.hasTimeRange === true || configuration.hasTimeRange === undefined) {
            configuration.timeRange = TimePeriod.Both;
        }
        configuration.hasTimeRange = null;
    }
    return configuration.timeRange;
}